import { colors } from '@lmc/common/constants'
import type React from 'react'
import styled from 'styled-components'
import { ProfilePicture } from '../ProfilePicture'

type ResidentData = {
  id: string
  name: { first: string; last: string }
  picture?: string
}

type ResidentPictureNameProps = {
  data?: ResidentData
  isLogRemoved?: boolean
  onSelect: (path: string) => void
  style?: React.CSSProperties
  testId?: string
}

export default function ResidentPictureName({
  data,
  isLogRemoved,
  onSelect,
  style,
  testId
}: ResidentPictureNameProps) {
  const redirect = () => onSelect(`residents/${data!.id}/profile`)
  if (!data || !data.id) return <ResidentContainer />

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    marginRight: 12,
    minWidth: 160,
    ...style
  }

  return (
    <div
      style={containerStyle}
      data-testid={testId ? `${testId}-resident-container` : undefined}
    >
      <Clickable
        onClick={redirect}
        data-testid={testId ? `${testId}-resident-picture` : undefined}
      >
        {isLogRemoved ? (
          <ProfilePicGreyed url={data.picture} size={46} />
        ) : (
          <ProfilePicNormal url={data.picture} size={46} />
        )}
      </Clickable>
      <TitleLink
        onClick={redirect}
        style={{
          marginTop: 12,
          color: isLogRemoved ? colors.darkgrey : undefined,
          overflowWrap: 'anywhere'
        }}
        data-testid={testId ? `${testId}-resident-name` : undefined}
      >
        {data.name.first} {data.name.last}
      </TitleLink>
    </div>
  )
}

const Clickable = styled.div`
  cursor: pointer;
`

const ProfilePicGreyed = styled(ProfilePicture)`
  margin-right: 12px;
  opacity: 0.2;
`

const ProfilePicNormal = styled(ProfilePicture)`
  margin-right: 12px;
`

const ResidentContainer = styled.div`
  display: flex;
  margin-right: 12px;
  min-width: 160px;
`

const TitleLink = styled.a`
  color: ${colors.black};
  cursor: pointer;
  display: block;
  font-weight: 600;
`
